import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    teamSize: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // EmailJS configuration
      const serviceID = 'service_47vu2xk';
      const templateID = 'template_c8bqnbc';
      const publicKey = 'qBsdiYjdxhePVOi7C';

      // Send email using EmailJS
      const result = await emailjs.send(
        serviceID,
        templateID,
        {
          from_name: formData.name,
          from_email: formData.email,
          company: formData.company,
          phone: formData.phone,
          team_size: formData.teamSize,
          message: formData.message,
          to_email: 'rusthique2002@gmail.com'
        },
        publicKey
      );

      console.log('Email sent successfully:', result);
      alert('Thank you for your inquiry! Our enterprise team will contact you within one business day.');
      
      // Reset form
      setFormData({ 
        name: '', 
        email: '', 
        company: '', 
        phone: '', 
        teamSize: '', 
        message: '' 
      });
    } catch (error) {
      console.error('Email send failed:', error);
      alert('Sorry, there was an error submitting your form. Please try again or contact us directly at rusthique2002@gmail.com');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Hero Header */}
      <section style={{
        background: '#000000',
        padding: '6rem 0',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `
            linear-gradient(rgba(168, 85, 247, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(168, 85, 247, 0.03) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }}></div>
        
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'radial-gradient(circle at 50% 50%, rgba(168, 85, 247, 0.1) 0%, transparent 70%)',
          pointerEvents: 'none'
        }}></div>
        
        <div className="container" style={{ maxWidth: '900px', position: 'relative', zIndex: 1, textAlign: 'center' }}>
          <div data-aos="fade-down" style={{ marginBottom: '1.5rem' }}>
            <span style={{
              display: 'inline-block',
              padding: '0.5rem 1.25rem',
              background: 'rgba(168, 85, 247, 0.15)',
              border: '1px solid rgba(168, 85, 247, 0.3)',
              borderRadius: '50px',
              color: '#a855f7',
              fontSize: '0.9rem',
              fontWeight: '600',
              fontFamily: "'Space Grotesk', sans-serif"
            }}>
              Enterprise Solutions
            </span>
          </div>
          
          <h1 data-aos="fade-up" style={{ 
            fontSize: 'clamp(2.5rem, 5vw, 4rem)', 
            color: 'white',
            marginBottom: '1.5rem',
            fontWeight: '300',
            lineHeight: '1.2',
            fontFamily: "'Space Grotesk', sans-serif"
          }}>
            Transform Your Organization
            <br />
            <span style={{
              background: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
              With Enterprise AI
            </span>
          </h1>
          
          <p data-aos="fade-up" data-aos-delay="100" style={{ 
            fontSize: '1.25rem',
            color: 'rgba(255, 255, 255, 0.7)',
            maxWidth: '600px',
            margin: '0 auto 2.5rem',
            lineHeight: '1.6',
            fontFamily: "'Inter', sans-serif",
            fontWeight: '300'
          }}>
            Connect with our solutions architects to explore how AI can accelerate your digital transformation initiatives.
          </p>

          {/* Trust badges */}
          <div data-aos="fade-up" data-aos-delay="200" style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '2rem',
            flexWrap: 'wrap',
            fontSize: '0.9rem',
            color: 'rgba(255, 255, 255, 0.6)',
            fontFamily: "'Inter', sans-serif"
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.5 10.5l-4 4L10 12" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="10" cy="10" r="8" stroke="#10b981" strokeWidth="1.5"/>
              </svg>
              24-hour response time
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.5 10.5l-4 4L10 12" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="10" cy="10" r="8" stroke="#10b981" strokeWidth="1.5"/>
              </svg>
              Complimentary assessment
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.5 10.5l-4 4L10 12" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="10" cy="10" r="8" stroke="#10b981" strokeWidth="1.5"/>
              </svg>
              No commitment required
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section style={{ padding: '6rem 0', background: '#fafafa' }}>
        <div className="container" style={{ maxWidth: '1200px' }}>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: '1fr 1fr', 
            gap: '4rem'
          }}>
            
            {/* Contact Form */}
            <div data-aos="fade-right">
              <h2 style={{ 
                fontSize: '2rem', 
                marginBottom: '1rem', 
                fontWeight: '400',
                fontFamily: "'Space Grotesk', sans-serif",
                color: '#1a1a1a'
              }}>
                Schedule Enterprise Consultation
              </h2>
              <p style={{ 
                color: '#666', 
                marginBottom: '2.5rem', 
                fontSize: '1.05rem',
                fontFamily: "'Inter', sans-serif",
                fontWeight: '300'
              }}>
                Complete the form below and our enterprise solutions team will contact you within one business day.
              </p>
              
              <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '1.5rem' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      fontSize: '0.95rem',
                      color: '#1a1a1a',
                      fontFamily: "'Space Grotesk', sans-serif"
                    }}>
                      Full Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                      style={{
                        width: '100%',
                        padding: '0.875rem 1rem',
                        border: '2px solid rgba(168, 85, 247, 0.2)',
                        borderRadius: '10px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none',
                        fontFamily: "'Inter', sans-serif",
                        background: 'white',
                        opacity: isSubmitting ? 0.6 : 1
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#a855f7';
                        e.target.style.boxShadow = '0 0 0 3px rgba(168, 85, 247, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = 'rgba(168, 85, 247, 0.2)';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                  
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      fontSize: '0.95rem',
                      color: '#1a1a1a',
                      fontFamily: "'Space Grotesk', sans-serif"
                    }}>
                      Business Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                      style={{
                        width: '100%',
                        padding: '0.875rem 1rem',
                        border: '2px solid rgba(168, 85, 247, 0.2)',
                        borderRadius: '10px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none',
                        fontFamily: "'Inter', sans-serif",
                        background: 'white',
                        opacity: isSubmitting ? 0.6 : 1
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#a855f7';
                        e.target.style.boxShadow = '0 0 0 3px rgba(168, 85, 247, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = 'rgba(168, 85, 247, 0.2)';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      fontSize: '0.95rem',
                      color: '#1a1a1a',
                      fontFamily: "'Space Grotesk', sans-serif"
                    }}>
                      Organization *
                    </label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                      style={{
                        width: '100%',
                        padding: '0.875rem 1rem',
                        border: '2px solid rgba(168, 85, 247, 0.2)',
                        borderRadius: '10px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none',
                        fontFamily: "'Inter', sans-serif",
                        background: 'white',
                        opacity: isSubmitting ? 0.6 : 1
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#a855f7';
                        e.target.style.boxShadow = '0 0 0 3px rgba(168, 85, 247, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = 'rgba(168, 85, 247, 0.2)';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                  
                  <div>
                    <label style={{ 
                      display: 'block', 
                      marginBottom: '0.5rem',
                      fontWeight: '500',
                      fontSize: '0.95rem',
                      color: '#1a1a1a',
                      fontFamily: "'Space Grotesk', sans-serif"
                    }}>
                      Contact Number
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      disabled={isSubmitting}
                      style={{
                        width: '100%',
                        padding: '0.875rem 1rem',
                        border: '2px solid rgba(168, 85, 247, 0.2)',
                        borderRadius: '10px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        outline: 'none',
                        fontFamily: "'Inter', sans-serif",
                        background: 'white',
                        opacity: isSubmitting ? 0.6 : 1
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#a855f7';
                        e.target.style.boxShadow = '0 0 0 3px rgba(168, 85, 247, 0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = 'rgba(168, 85, 247, 0.2)';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                </div>

                <div>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '0.5rem',
                    fontWeight: '500',
                    fontSize: '0.95rem',
                    color: '#1a1a1a',
                    fontFamily: "'Space Grotesk', sans-serif"
                  }}>
                    Organization Size
                  </label>
                  <select
                    name="teamSize"
                    value={formData.teamSize}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    style={{
                      width: '100%',
                      padding: '0.875rem 1rem',
                      border: '2px solid rgba(168, 85, 247, 0.2)',
                      borderRadius: '10px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      background: 'white',
                      fontFamily: "'Inter', sans-serif",
                      opacity: isSubmitting ? 0.6 : 1
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#a855f7';
                      e.target.style.boxShadow = '0 0 0 3px rgba(168, 85, 247, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(168, 85, 247, 0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    <option value="">Select organization size</option>
                    <option value="1-10">1-10 employees</option>
                    <option value="11-50">11-50 employees</option>
                    <option value="51-200">51-200 employees</option>
                    <option value="201-500">201-500 employees</option>
                    <option value="501-1000">501-1,000 employees</option>
                    <option value="1000+">1,000+ employees</option>
                  </select>
                </div>

                <div>
                  <label style={{ 
                    display: 'block', 
                    marginBottom: '0.5rem',
                    fontWeight: '500',
                    fontSize: '0.95rem',
                    color: '#1a1a1a',
                    fontFamily: "'Space Grotesk', sans-serif"
                  }}>
                    Business Requirements *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    disabled={isSubmitting}
                    style={{
                      width: '100%',
                      padding: '0.875rem 1rem',
                      border: '2px solid rgba(168, 85, 247, 0.2)',
                      borderRadius: '10px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      resize: 'vertical',
                      fontFamily: "'Inter', sans-serif",
                      background: 'white',
                      opacity: isSubmitting ? 0.6 : 1
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#a855f7';
                      e.target.style.boxShadow = '0 0 0 3px rgba(168, 85, 247, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = 'rgba(168, 85, 247, 0.2)';
                      e.target.style.boxShadow = 'none';
                    }}
                  ></textarea>
                  <p style={{ 
                    fontSize: '0.85rem', 
                    color: '#666', 
                    marginTop: '0.5rem',
                    fontFamily: "'Inter', sans-serif"
                  }}>
                    Please describe your business objectives, technical requirements, and implementation timeline.
                  </p>
                </div>

                <button 
                  type="submit" 
                  disabled={isSubmitting}
                  style={{
                    padding: '1rem 2rem',
                    background: isSubmitting ? '#999' : 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '10px',
                    fontSize: '1.05rem',
                    fontWeight: '600',
                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.75rem',
                    boxShadow: '0 4px 12px rgba(168, 85, 247, 0.3)',
                    transition: 'all 0.3s ease',
                    fontFamily: "'Space Grotesk', sans-serif",
                    opacity: isSubmitting ? 0.7 : 1
                  }}
                  onMouseEnter={(e) => {
                    if (!isSubmitting) {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 6px 20px rgba(168, 85, 247, 0.4)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 12px rgba(168, 85, 247, 0.3)';
                  }}
                >
                  {isSubmitting ? 'Sending...' : 'Submit Inquiry'}
                  {!isSubmitting && (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </button>

                {/* FIXED: Removed invalid href="#" links */}
                <p style={{ 
                  fontSize: '0.875rem', 
                  color: '#666', 
                  marginTop: '0.5rem',
                  fontFamily: "'Inter', sans-serif"
                }}>
                  By submitting this form, you acknowledge our{' '}
                  <button 
                    type="button"
                    onClick={() => alert('Privacy Policy page coming soon')}
                    style={{ 
                      color: '#a855f7', 
                      textDecoration: 'underline', 
                      fontWeight: '500',
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      cursor: 'pointer',
                      font: 'inherit'
                    }}
                  >
                    privacy policy
                  </button>{' '}
                  and{' '}
                  <button 
                    type="button"
                    onClick={() => alert('Terms of Service page coming soon')}
                    style={{ 
                      color: '#a855f7', 
                      textDecoration: 'underline', 
                      fontWeight: '500',
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      cursor: 'pointer',
                      font: 'inherit'
                    }}
                  >
                    terms of service
                  </button>.
                </p>
              </form>
            </div>

            {/* Contact Info & Cards */}
            <div data-aos="fade-left">
              <div style={{ 
                position: 'sticky', 
                top: '100px',
                display: 'grid',
                gap: '2rem'
              }}>
                {/* Quick Contact Cards */}
                {[
                  {
                    icon: (
                      <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" width="24" height="24">
                        <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                      </svg>
                    ),
                    title: 'Enterprise Sales',
                    content: 'rusthique2002@gmail.com',
                    subtitle: 'Priority response within 24 hours'
                  },
                  {
                    icon: (
                      <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" width="24" height="24">
                        <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                      </svg>
                    ),
                    title: 'Direct Line',
                    content: '+91 9567027700',
                    subtitle: 'Available Monday-Friday, 9:00 AM - 6:00 PM IST'
                  },
                  {
                    icon: (
                      <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" width="24" height="24">
                        <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                        <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                      </svg>
                    ),
                    title: 'Office Locations',
                    content: 'India and UAE',
                    subtitle: 'Serving clients globally'
                  }
                ].map((item, idx) => (
                  <div key={idx} style={{
                    padding: '2rem',
                    background: 'white',
                    borderRadius: '16px',
                    border: '1px solid rgba(168, 85, 247, 0.1)',
                    boxShadow: '0 4px 12px rgba(168, 85, 247, 0.08)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(168, 85, 247, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(168, 85, 247, 0.08)';
                  }}
                  >
                    <div style={{
                      width: '56px',
                      height: '56px',
                      borderRadius: '12px',
                      background: 'linear-gradient(135deg, #a855f7, #ec4899)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '1.5rem',
                      boxShadow: '0 4px 12px rgba(168, 85, 247, 0.25)'
                    }}>
                      {item.icon}
                    </div>
                    <h3 style={{ 
                      fontSize: '1.25rem', 
                      marginBottom: '0.5rem', 
                      fontWeight: '500',
                      fontFamily: "'Space Grotesk', sans-serif",
                      color: '#1a1a1a'
                    }}>
                      {item.title}
                    </h3>
                    <p style={{ 
                      fontSize: '1.05rem', 
                      color: '#a855f7', 
                      fontWeight: '600', 
                      marginBottom: '0.25rem',
                      fontFamily: "'Inter', sans-serif"
                    }}>
                      {item.content}
                    </p>
                    <p style={{ 
                      fontSize: '0.9rem', 
                      color: '#666',
                      fontFamily: "'Inter', sans-serif"
                    }}>
                      {item.subtitle}
                    </p>
                  </div>
                ))}

                {/* Trust Section */}
                <div style={{
                  padding: '2rem',
                  background: 'linear-gradient(135deg, rgba(168, 85, 247, 0.05), rgba(236, 72, 153, 0.05))',
                  borderRadius: '16px',
                  border: '1px solid rgba(168, 85, 247, 0.15)'
                }}>
                  <h4 style={{ 
                    fontSize: '1.1rem', 
                    marginBottom: '1rem', 
                    fontWeight: '500',
                    fontFamily: "'Space Grotesk', sans-serif",
                    color: '#1a1a1a'
                  }}>
                    Enterprise Advantages
                  </h4>
                  <ul style={{ listStyle: 'none', padding: 0, display: 'grid', gap: '0.75rem' }}>
                    {[
                      'Bank-level security infrastructure',
                      'SOC 2 Type II audited annually',
                      '99.9% guaranteed uptime SLA',
                      'Dedicated customer success team'
                    ].map((item, idx) => (
                      <li key={idx} style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '0.75rem',
                        fontSize: '0.95rem',
                        color: '#333',
                        fontFamily: "'Inter', sans-serif"
                      }}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <circle cx="10" cy="10" r="10" fill="rgba(16, 185, 129, 0.15)"/>
                          <path d="M6 10l2.5 2.5L14 8" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
